// The page text pre-built at publish time (scripts/ssr-pages.js), captured before React replaces #root.
const el = typeof document !== "undefined" ? document.querySelector("#root > [data-ssr]") : null;
const snapshot = el ? { path: window.location.pathname, html: el.innerHTML } : null;

const ssrFor = (pathname) => (snapshot && snapshot.path === pathname ? snapshot.html : null);

// Shows the pre-built recipe/cookbook text while the live data loads, or if it can't be fetched.
export function SsrFallback({ pathname }) {
  const html = ssrFor(pathname);
  if (!html) return null;
  return <div className="max-w-3xl mx-auto px-6 py-10 text-rf-ink leading-relaxed ssr-fallback" data-testid="ssr-fallback" dangerouslySetInnerHTML={{ __html: html }} />;
}

export const hasSsr = (pathname) => !!ssrFor(pathname);
